export const versionNumber: VersionNumber = {
  releaseDate: 1741610666000,
  versionNumber: 1741610666000,
};

interface VersionNumber {
  releaseDate: number;
  versionNumber: number;
}
